import { render } from "./IconsSidebar.vue?vue&type=template&id=20a714e0&scoped=true"
import script from "./IconsSidebar.vue?vue&type=script&lang=js"
export * from "./IconsSidebar.vue?vue&type=script&lang=js"

import "./IconsSidebar.vue?vue&type=style&index=0&id=20a714e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a714e0"]])

export default __exports__